// @flow
import styled, { keyframes } from 'styled-components';

import LogoAnimation from '~/assets/images/splashscreen-animation.png';
import { media } from '~/core/utils/style';

const imageChange = keyframes`
	0% { background-position: 0 0%; }
	8% { background-position: 0 12.5%% }
	12% { background-position: 0 25%; }
	16% { background-position: 0 37.5%; }
	20% { background-position: 0 50%; }
	24% { background-position: 0 62.5%; }
	28% { background-position: 0 75%; }
	32% { background-position: 0 87.5%; }
	36% { background-position: 0 100%; }
	40% { background-position: 0 0%; }
	100% { background-position: 0 0%; }
`;

export const AnimationContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const LogoContainer = styled.div`
    animation: ${imageChange} 2.5s infinite step-end;
    background: url(${LogoAnimation}) no-repeat;
    background-size: 100%;
    width: 10rem;
    height: 10rem;
    ${media.tablet`
		width: 12rem;
		height: 12rem;
	`};
`;



// WEBPACK FOOTER //
// ./src/components/widgets/indicators/waiting/styles.js